import React from "react";
import { useAuth } from "react-uicomp";
import H1 from "../../../assets/gallery/a2.JPG";
export const Intro = () => {
  const { language } = useAuth();
  return (
    <div className="IntroCard-wrapper">
      <div className="container">
        <div className="card">
          <div className="left">
            <div className="title">{language.key.whoweare}</div>
            <div className="paragraph">
              <p>{language.key.homepage.introductionfull}</p>
            </div>
          </div>
          <div className="right">
            <img src={H1} alt="introduction" />
          </div>
        </div>
      </div>
    </div>
  );
};
